export const Routing = {
    Account: {
        SIGNIN: "/account/signin",
        SIGNOUT: "/account/signout",
    },
};
